import { useState, useEffect } from 'react';
import StartSavingModal from 'components/shared/modal/StartSavingsModal';
import { useSelector } from 'react-redux';
import { selectInterestRate } from 'store/slices/savings';
import { useDispatch } from 'react-redux';
import { setInterestRate } from 'store/slices/savings';
import { appAxios } from 'api/axios';
import { RoutePaths } from 'routes/route-paths';
import { useNavigate } from 'react-router-dom';

function NoSavingsYet() {
  const navigate = useNavigate();
  const [isModalOpen, setIsModalOpen] = useState<boolean>(false);
  const interestRate = useSelector(selectInterestRate);
  const dispatch = useDispatch();

  useEffect(() => {
    const fetchInterestRate = async () => {
      try {
        // Check if we already have the interest rate in the Redux store
        if (interestRate > 0) {
          return;
        }

        // If not in store, fetch from API
        const { data } = await appAxios.get('/get-savings-type');
        if (data && data.success) {
          const jompVaultData = data.data.find(
            (item: any) => item.name === 'jompVault'
          );
          if (jompVaultData) {
            const rate = jompVaultData.interestRate;
            dispatch(setInterestRate(rate));
          }
        }
      } catch (error) {
        console.error('Error fetching interest rate:', error);
      }
    };

    fetchInterestRate();
  }, [dispatch, interestRate]);

  const handleStartSavings = () => {
    setIsModalOpen(false); // Close the modal
    navigate(RoutePaths.USER_CREATE_SAVINGS_JOMPVAULT);
  };

  return (
    <div className="flex flex-col gap-y-2 justify-center items-center">
      <figure>
        <img src="/svgs/saveMoney.svg" alt="piggy_ban_icon" />
      </figure>
      <div className="flex flex-col gap-y-2 justify-center items-center mb-4 lg:mb-0">
        <h1 className="font-bold text-l">No Savings Yet!</h1>
      </div>
      <button
        className="py-2 px-4 bg-[#EFA005] text-white hover:bg-[#e9b959] rounded-md"
        onClick={() => setIsModalOpen(true)}
      >
        Start New Savings
      </button>

      <StartSavingModal
        isOpen={isModalOpen}
        onClose={() => setIsModalOpen(false)}
        title=""
        subtitle=""
        btnText="Proceed"
        onAction={handleStartSavings}
      />
    </div>
  );
}

export default NoSavingsYet;
